import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchPieceGestionLignes } from 'store/pieceGestionLigne/pieceGestionLigneActions';
import { fetchColisLogistique } from 'store/colisLogistique/colisLogistiqueActions';
import { closeAddReclamationDialog } from 'store/common/commonActions';

import PieceGestionSearchResult from './PieceGestionSearchResult';

class PieceGestionSearchResultContainer extends React.Component {
    handleSelectPiece = (oldNumeroPiece, newNumeroPiece) => {
        const { onSelectPiece, withLignes, fetchPieceGestionLignes, fetchColisLogistique, defautProduitInfos, logistiqueInfos, savInfos, codeDepot, piecesGestion } = this.props;

        let newPiece = piecesGestion.find(x => x.numeroPiece === newNumeroPiece)

        // Clé technique pour les appels API (BL ou DT) — fallback sur numeroPiece pour le legacy
        const cleApi = newPiece?.bonLivraisonGestionCle || newPiece?.demandeTransfertGestionCle || newNumeroPiece;

        if (withLignes && oldNumeroPiece !== newNumeroPiece) {
            fetchPieceGestionLignes(cleApi, defautProduitInfos, logistiqueInfos, savInfos, codeDepot);
            fetchColisLogistique(cleApi);
        }

        onSelectPiece(newNumeroPiece, newPiece);
    }

    render() {
        const {
            piecesGestion,
            afterSearch,
            high,
            warningReclamation,
            warningCancel,
            filterIMM30,
            warningLivraison,
            warningCommandeLivraisonDirecte,
            cacherTableResultat,
            afficheApplication,
            afficheJson,
            disableMixLignesPositivesNegatives,
            autoriserToutePieceDuJour
        } = this.props;

        return (
            <PieceGestionSearchResult
                piecesGestion={piecesGestion}
                onSelectPiece={this.handleSelectPiece}
                afterSearch={afterSearch}
                high={high}
                warningReclamation={warningReclamation}
                warningCancel={warningCancel}
                filterIMM30={filterIMM30}
                warningLivraison={warningLivraison}
                warningCommandeLivraisonDirecte={warningCommandeLivraisonDirecte}
                cacherTableResultat={cacherTableResultat}
                afficheApplication={afficheApplication}
                afficheJson={afficheJson}
                disableMixLignesPositivesNegatives={disableMixLignesPositivesNegatives}
                autoriserToutePieceDuJour={autoriserToutePieceDuJour}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

    let afficheApplication = utilisateur && (utilisateur.id === 11 || utilisateur.id === 531);
    let afficheJson = utilisateur && (utilisateur.id === 11 || utilisateur.id === 531);

    let piecesGestion = state.pieceGestion[ownProps.namespace].piecesGestion.items;

    return {
        piecesGestion: piecesGestion,
        afterSearch: state.pieceGestion[ownProps.namespace].piecesGestion.afterSearch,
        afficheApplication: afficheApplication,
        afficheJson: afficheJson
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchPieceGestionLignes: (numeroPiece, defautProduitInfos, logistiqueInfos, savInfos, codeDepot) => dispatch(fetchPieceGestionLignes(numeroPiece, defautProduitInfos, logistiqueInfos, savInfos, codeDepot)),
    fetchColisLogistique: (numeroPiece) => dispatch(fetchColisLogistique(numeroPiece)),
    warningCancel: () => dispatch(closeAddReclamationDialog())
});

PieceGestionSearchResultContainer.propTypes = {
    onSelectPiece: PropTypes.func.isRequired,
    withLignes: PropTypes.bool.isRequired,
    high: PropTypes.bool,
    warningReclamation: PropTypes.bool.isRequired,
    defautProduitInfos: PropTypes.bool.isRequired,
    cacherTableResultat: PropTypes.bool.isRequired,
    filterIMM30: PropTypes.bool,
    warningLivraison: PropTypes.bool.isRequired,
    savInfos: PropTypes.bool.isRequired,
    codeDepot: PropTypes.string,

    disableMixLignesPositivesNegatives: PropTypes.bool,
    autoriserToutePieceDuJour: PropTypes.bool,
};

PieceGestionSearchResultContainer.defaultProps = {
    disableMixLignesPositivesNegatives: false,
    autoriserToutePieceDuJour: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PieceGestionSearchResultContainer));
